/* eslint-disable quote-props */
import commonStyles from './commonStyles';

const {
  backgroundColor,
  textColor,
  primaryColor,
  dividerColor
} = commonStyles;

export const sectionWrapperStyles = {
  'background-color': backgroundColor,
  'padding-bottom': '15rem',
  'padding-top': '11rem',
  'width': '100%'
};

export const horizontalWrapperStyles = {
  'display': 'flex',
};

export const sectionWrapperTabletStyles = {
  'padding-bottom': '12rem',
  'padding-top': '8rem',
};

export const sectionWrapperMobileStyles = {
  'padding-bottom': '10rem',
  'padding-top': '8rem',
};

export const wrapperWithMarginStyles = {
  'width': '75%',
  'max-width': '160rem',
  'margin-left': 'auto',
  'margin-right': 'auto',
};

export const dividerStyles = {
  'width': '75%',
  'max-width': '160rem',
  'margin-left': '0',
  'margin-right': 'auto',
  'border-top-width': '2px',
  'border-top-style': 'solid',
  'border-top-color': dividerColor,
};

export const wrapperWithMarginTabletStyles = {
  'width': '90%',
  'margin-left': 'auto',
  'margin-right': 'auto',
};

export const galleryRoundTilesStyles = {
  'height': '40rem',
  'background-size': 'cover',
  'background-repeat': 'no-repeat',
};

export const galleryRoundTilesMobileStyles = {
  'width': '100%',
  'height': '20rem',
  'margin-bottom': '1rem'
};

export const avatarStyles = {
  'width': '15rem',
  'height': '15rem',
  'border-top-left-radius': '8rem',
  'border-bottom-left-radius': '8rem',
  'border-top-right-radius': '8rem',
  'border-bottom-right-radius': '8rem',
};

export const avatarStylesMobile = {
  'width': '10rem',
  'height': '10rem',
  'border-top-left-radius': '5rem',
  'border-bottom-left-radius': '5rem',
  'border-top-right-radius': '5rem',
  'border-bottom-right-radius': '5rem',
};

export const tagStyles = {
  'height': '2.5rem',
  'width': 'fit-content',
  'border-top-left-radius': '2rem',
  'border-bottom-left-radius': '2rem',
  'border-top-right-radius': '2rem',
  'border-bottom-right-radius': '2rem',
  'color': '#FFFFFF',
  'padding-left': '1rem',
  'padding-right': '1rem',
};

export const avatarLogoContainerStyles = {
  'display': 'block',
  'position': 'absolute',
  'right': '0',
  'bottom': '0',
  'width': '8rem',
  'height': '8rem',
  'border-top-left-radius': '4rem',
  'border-bottom-left-radius': '4rem',
  'border-top-right-radius': '4rem',
  'border-bottom-right-radius': '4rem',
  'background-color': '#FFFFFFE6'
};

export const avatarLogoContainerMobileStyles = {
  'width': '4rem',
  'height': '4rem',
  'border-top-left-radius': '2rem',
  'border-bottom-left-radius': '2rem',
  'border-top-right-radius': '2rem',
  'border-bottom-right-radius': '2rem',
};

export const avatarLogoStyles = {
  'display': 'block',
  'position': 'relative',
  'width': '100%',
  'height': '100%',
  'background-repeat': 'no-repeat',
  'background-position': 'center',
  'background-size': 'cover'
};

export const socialMediaIconStyles = {
  'width': '4rem',
  'height': '4rem',
  'border-top-left-radius': '3rem',
  'border-bottom-left-radius': '3rem',
  'border-top-right-radius': '3rem',
  'border-bottom-right-radius': '3rem',
  'background-color': '{socialIconBackgroundColor}',
  'background-size': '50%',
  'background-position': 'center',
  'background-repeat': 'no-repeat',
};

export const iconStyles = {
  'width': '5rem',
  'height': '5rem',
  'border-top-left-radius': '3rem',
  'border-bottom-left-radius': '3rem',
  'border-top-right-radius': '3rem',
  'border-bottom-right-radius': '3rem',
  'background-color': '{iconBackgroundColor}',
  'background-size': '50%',
  'background-position': 'center',
  'background-repeat': 'no-repeat',
};

export const horizontalDark = {
  'width': '100%',
  'height': '1px',
  'background-color': '{primaryColor}'
};

export const typoQuote = {
  'font-size': '48px',
  'font-weight': '400',
  'font-family': '{mainFont}',
  'color': '{textColor}',
};

export const typoQuoteTablet = {
  'font-size': '30px',
  'font-weight': '400',
  'font-family': '{mainFont}',
  'color': '{textColor}',
};

export const typoLargeNumber = {
  'font-size': '80px',
  'font-weight': '400',
  'font-family': '{mainFont}',
  'color': '{textColor}',
};

export const typoSmallHeader = {
  'font-size': '24px',
  'font-weight': '400',
  'color': '{textColor}',
};

export const typoLargeHeader = {
  'font-size': '80px',
  'font-weight': '700',
  'color': '{textColor}',
};

export const typoLargeHeaderMobile = {
  'font-size': '50px',
  'font-weight': '700',
  'color': '{textColor}',
};

export const typoHeader = {
  'font-size': '36px',
  'color': '{primaryColor}',
  'font-family': '{mainFont}',
  'margin-bottom': '4rem'
};

export const typoHeaderMobile = {
  'font-size': '24px',
  'color': '{primaryColor}',
  'font-family': '{mainFont}',
  'margin-bottom': '2rem'

};

export const typoParagraph = {
  'font-size': '16px',
  'color': '{textColor}',
  'line-height': '1.5',
  'font-size': '1.8rem',
};

export const typoSmallParagraph = {
  'font-size': '14px',
  'color': '{textColor}',
};

export const typoLink = {
  'font-size': '12px',
  'color': '#ffffff',
};

export const typoSmall = {
  'font-size': '14px',
  'color': '{primaryColor}',
};


export const typoAgendaSmall = {
  'font-size': '12px',
  'color': '{textColor}'
};

export const typoNavigation = {
  'font-size': '1.4rem',
};

export default [
  sectionWrapperStyles,
  sectionWrapperTabletStyles,
  sectionWrapperMobileStyles,
  wrapperWithMarginStyles,
  wrapperWithMarginTabletStyles,
  galleryRoundTilesStyles,
  galleryRoundTilesMobileStyles,
  avatarStyles,
  avatarStylesMobile,
  avatarLogoContainerStyles,
  avatarLogoContainerMobileStyles,
  avatarLogoStyles,
  socialMediaIconStyles,
  iconStyles,
  horizontalDark,
  typoSmallHeader,
  typoHeader,
  typoHeaderMobile,
  typoQuote,
  typoQuoteTablet,
  typoLargeNumber,
  typoLargeHeader,
  typoLargeHeaderMobile,
  typoParagraph,
  typoSmallParagraph,
  typoLink,
  typoSmall,
  typoAgendaSmall,
  typoNavigation
];
